import { render, staticRenderFns } from "./Hospitals.vue?vue&type=template&id=e6380d18&scoped=true"
import script from "./Hospitals.vue?vue&type=script&lang=js"
export * from "./Hospitals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6380d18",
  null
  
)

export default component.exports